<template>
  <div class="">
    <div class="row response-card-block">
      <div class="display-flex" style="padding-right: 12px; padding-left: 12px;">
        <div class="banner mb-4 mob-banner" >
          <VtbBanner />
        </div>
      </div>
      <div class="row col flex_column mob">
        <div class="col-12 col-md-12 col-lg-6 mob">
          <div class="row">
            <div class="col-12">
              <div class="card">
                <div class="card-body">
                  <h5 class="card-title font-weight-bold">Տենդերներ</h5>
                  <p>Դիտել ընտրված կատեգորիաներին համապատասխանող տենդերների ցուցակը</p>
                  <a @click="$router.push(`/participant/tenders`);" href="#" class="btn btn-primary w-100">Հետաքրքրող տենդերներ</a>
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="card">
                <div class="card-body">
                  <h5 class="card-title font-weight-bold">Երաշխիք</h5>
                  <p>Ստացեք արտոնյալ պայմաններով տենդերների վերաբեվող բանկային երաշխիքներ</p>
                  <a @click="$modal.show('guarantee-modal')" href="#" class="btn btn-primary w-100">Դիմել երաշխիքի համար</a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xs-12 col-12 col-md-12 col-lg-6 mob">
          <div class="card">
            <div class="card-body">
              <h4 class="card-title font-weight-bold">Ուղեցույց</h4>
              <h5 class="card-title font-weight-bold">մրցույթների մասնակցության</h5>
              <p>iTender համակարգում /այսուհետ՝ Համակարգ/ տեղադրված մրցույթներին մասնակցելու համար /բացառությամբ Համակարգի միջոցով կազմակերպված տենդերների և «Անժամկետ տենդերներ» հարթակի տենդերների, որոնց մասնակցությունը տեղի է ունենում Համակարգի միջոցով/ անհրաժեշտ է առաջին քայլով պատրաստել մրցույթի հայտ և հաջորդ քայլով ներկայացնել այն պատվիրատուին։</p>
              <div class="row">
                <div v-for="guide in guides" :key="guide.id"  class="col-12 my-2">
                  <button @click="() => $router.push(`/guide/${guide.id}`)" href="#" class="w-100 btn btn-primary">{{ guide.title.hy }}</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <guarantee-modal/>
  </div>
</template>

<script>
import GuaranteeModal from '@/components/landing/GuaranteeModal'
import VtbBanner from '@/components/dashboard/banner'

export default {
  components: { GuaranteeModal, VtbBanner },
  data() {
    return { 
      guides: []
    }
  },
  mounted(){
    this.$client.get('guide').then(({data}) => {
      this.guides = data
    })
  },
}
</script>

<style scop
    GuaranteeModaled>
/* .banner{
  width: 400px;
  height: 300px;
  background-color: #fff;
} */
.banner iframe{
  border-radius: .25rem;
}
@media only screen and (max-width: 1450px) {
  .response-card-block{
    flex-direction: column;
  }
}
@media only screen and (max-width: 900px) {
  .flex_column{
    flex-direction: column;
  }
}
@media only screen and (max-width: 540px) {
  .mob-banner{
    width: 100% !important;
  }
  .mob{
    padding-right: 0;
  }
  .w-100{
    width: 100%;
  }
}
</style>
